
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spremeni-geslo",
      function () {
        return require("private-next-pages/spremeni-geslo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spremeni-geslo"])
      });
    }
  